import React from 'react';
import { useDialogStore } from '../../../stores/dialogStore';
import { ConfirmDialog } from './ConfirmDialog';
import { AlertDialog } from './AlertDialog';
import { ConfirmDialogOptions, AlertDialogOptions } from '../../../types/dialog';

export const DialogProvider: React.FC = () => {
  const { isOpen, type, options, handleConfirm, handleCancel } = useDialogStore();

  if (!isOpen || !type || !options) {
    return null;
  }

  return (
    <>
      {type === 'confirm' && (
        <ConfirmDialog
          isOpen={isOpen}
          options={options as ConfirmDialogOptions}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      {type === 'alert' && (
        <AlertDialog
          isOpen={isOpen}
          options={options as AlertDialogOptions}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};